import {useDropzone} from 'react-dropzone'
import cn from "classnames";

const Dropzone = ({ onDrop, image }) => {
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

  const text = isDragActive ?
    <p>Для загрузки, перетащите файл сюда...</p> :
    <p>Перетащите файл сюда или нажмите чтобы выбрать файл</p>;

  const className = cn('xti-dropzone', {
    'xti-dropzone--active': isDragActive,
  })

  return (
    <div {...getRootProps({ className } )}>
      <input {...getInputProps()} />
      {
        image ?
          <img className="xti-dropzone__image" src={image} alt={image}/> :
          text
      }
    </div>
  )
}

export default Dropzone;
